import { createReducer, on } from '@ngrx/store';
import * as userActions from './user.action';
import { UserModel } from '../../../models/vet-users/user.model';

export interface UserState {
  users: UserModel[];
  loading: boolean;
  success: any | null;
  error: any;
  user: UserModel;

}

export const initialState: UserState = {
  users: [],
  loading: false,
  error: null,
  success: null,
  user: null
};

export const userReducer = createReducer(
  initialState,
  on(userActions.loadUsers, (state) => ({ ...state, loading: true })),
  on(userActions.loadUsersSuccess, (state, { users }) => ({ ...state, users, loading: false, error: null, success: {userList: true} })),
  on(userActions.loadUsersFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(userActions.saveUser, (state) => ({ ...state, loading: true })),
  on(userActions.saveUserSuccess, (state, { user }) => ({ ...state, loading: false, error: null, success: { saveUser: true } })),
  on(userActions.saveUserFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(userActions.forgotPasswordByUserId, (state) => ({ ...state, success: null, error: null })),
  on(userActions.forgotPasswordByUserIdSuccess, (state, { success }) => ({ ...state, success: { forgot: true } })),
  on(userActions.forgotPasswordByUserIdFailure, (state, { error }) => ({ ...state, error })),

  on(userActions.getUser, (state) => ({ ...state, loading: true, user: null, error: null })),
  on(userActions.getUserSuccess, (state, { user }) => ({ ...state, user, loading: false, success: { user: true } })),
  on(userActions.getUserFailure, (state, { error }) => ({ ...state, error, loading: false }))
);
